<script lang="ts" setup>
  import { TagIcon } from '@heroicons/vue/24/solid'
  import type { ResolvedActivity } from '@/stores'

  const props = defineProps<{
    activityItem: ResolvedActivity<'tags'>
  }>()
  const { activity } = props.activityItem
</script>

<template>
  <div class="relative flex items-start space-x-3">
    <div>
      <div class="relative px-1">
        <div class="flex h-8 w-8 items-center justify-center rounded-full bg-gray-100 ring-8 ring-white">
          <TagIcon
            aria-hidden="true"
            class="h-5 w-5 text-gray-500" />
        </div>
      </div>
    </div>
    <div class="min-w-0 flex-1 py-0">
      <div class="text-sm leading-8 text-gray-500">
        <span class="mr-0.5">
          <!--                        <a :href="activity.person.href" class="font-medium text-gray-900">{{-->
          <!--                          activity.person.name-->
          <!--                        }}</a>-->
          {{ ' ' }}
          added tags
        </span>
        {{ ' ' }}
        <span class="mr-0.5">
          <template
            v-for="tag in activity.data.tags"
            :key="typeof tag === 'string' ? tag : tag.name">
            <span
              v-if="typeof tag === 'string'"
              class="inline-flex items-center gap-x-1.5 rounded-full px-2 py-1 text-xs font-medium text-gray-900 ring-1 ring-inset ring-gray-200">
              {{ tag }}
            </span>
            <a
              v-else
              :href="tag.href"
              class="inline-flex items-center gap-x-1.5 rounded-full px-2 py-1 text-xs font-medium text-gray-900 ring-1 ring-inset ring-gray-200">
              <svg
                :style="{ fill: tag.color }"
                aria-hidden="true"
                class="h-1.5 w-1.5"
                viewBox="0 0 6 6">
                <circle
                  cx="3"
                  cy="3"
                  r="3" />
              </svg>
              {{ tag.name }}
            </a>
            {{ ' ' }}
          </template>
        </span>
        <span class="whitespace-nowrap">{{ $formatter.DateTime(activity.createdAt!) }}</span>
      </div>
    </div>
  </div>
</template>
